import styled from 'styled-components';
import { BodyBoldL, BodyRegularL } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const LogoutCont = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 656px;
  justify-content: center;
`;

export const WelcomeMessage = styled(BodyRegularL)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `};
`;

export const WelcomeMessageBold = styled(BodyBoldL)``;

export const InformationTextCont = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.deka} 0;
    height: ${theme.layout.spacing.giga};
 `}
`;
